import React from "react";
import { TextField, Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  colorPreview: {
    width: "32px",
    height: "32px",
    borderRadius: "4px",
    border: `2px solid ${theme.palette.divider}`,
    flexShrink: 0,
  },
  textField: {
    "& .MuiInputBase-input": {
      padding: "8px 12px",
      fontFamily: "monospace",
    },
  },
  errorText: {
    fontSize: "0.75rem",
    color: theme.palette.error.main,
    marginTop: "4px",
  },
}));

const SimpleColorInput = ({
  value = "#000000",
  onChange,
  error = false,
  helperText = "",
  size = "small",
  className = "",
  ...props
}) => {
  const styles = useStyles();

  const isValidHex = (hex: any) => {
    return /^#[0-9A-Fa-f]{6}$/.test(hex);
  };

  const handleChange = (event: any) => {
    const newValue = event.target.value;
    onChange({
      target: {
        name: event.target.name,
        value: newValue,
      },
    });
  };

  const displayColor = isValidHex(value) ? value : "#000000";

  return (
    <Box className={`${styles.container} ${className}`}>
      <Box
        className={styles.colorPreview}
        style={{ backgroundColor: displayColor }}
        title={`Color preview: ${displayColor}`}
      />
      <Box flex={1}>
        <TextField
          {...props}
          value={value}
          onChange={handleChange}
          size={size as any}
          className={styles.textField}
          error={error || !isValidHex(value)}
          placeholder="#000000"
          inputProps={{
            maxLength: 7,
            pattern: "^#[0-9A-Fa-f]{6}$",
          }}
        />
        {(helperText || (!isValidHex(value) && value)) && (
          <Typography className={styles.errorText}>
            {helperText || "Invalid hex color format (e.g., #FF0000)"}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default SimpleColorInput;